import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/certification.css';
import '../../public/static/css/etc.css';
import { firebaseInit } from './firebase';
var FIRST_TAB = document.getElementsByClassName('tab1')[0];
var SECOND_TAB = document.getElementsByClassName('tab2')[0];
var FIRST_DIV = document.getElementsByClassName('tab-reason')[0];
var SECOND_DIV = document.getElementsByClassName('tab-info')[0];
var toggleActive = function (tab, isActive) {
    if (isActive) {
        tab.classList.add('active');
    }
    else {
        tab.classList.remove('active');
    }
};
var toggleDisplay = function (divElement, isShow) {
    divElement.style.display = isShow ? 'block' : 'none';
};
var setToggleEvent = function (isFirst) {
    toggleActive(isFirst ? FIRST_TAB : SECOND_TAB, true);
    toggleActive(isFirst ? SECOND_TAB : FIRST_TAB, false);
    toggleDisplay(isFirst ? FIRST_DIV : SECOND_DIV, true);
    toggleDisplay(isFirst ? SECOND_DIV : FIRST_DIV, false);
};
var setActiveLi = function (e) {
    var name = e.target.name;
    setToggleEvent(name === 'tab1');
};
var initialize = function () {
    firebaseInit();
    var ul = document.getElementsByClassName('sim-tab-ul')[0];
    if (ul) {
        ul.addEventListener('click', setActiveLi);
    }
    var btn = document.getElementsByClassName('btn-info');
    if (btn) {
        for (var i = 0; i < btn.length; i++) {
            btn[i].addEventListener('click', function () { return setToggleEvent(false); });
        }
    }
};
initialize();
